export default {
    data() {
        return {
          
        };
    },
    methods: {
        /**
         **@disc:获取region名字
         **@params:region
         */
        getRegionName(region) {
            return this.regions.find((item) => item.region === region).regionName
        },
    }
};


// WEBPACK FOOTER //
// ./src/mixins/regionName.js